import styled from 'styled-components';
import posed from 'react-pose';

import { fonts, colors } from '@/theme';

export const Container = styled.div`
  margin-bottom: 10px;
`;

export const TextInput = styled.input`
  ${fonts.getRegularText()}
  border: none;
  border-bottom: solid 1px #000000;
  width: 100%;

  :focus {
    outline: none;
  }

  ::placeholder {
    color: ${colors.form.placeholder};
  }
`;

export const TextArea = styled.textarea`
  ${fonts.getRegularText()}
  border: none;
  border-bottom: solid 1px #000000;
  width: 100%;
  padding: 0;
  min-height: 200px;

  :focus {
    outline: none;
  }

  ::placeholder {
    color: ${colors.form.placeholder};
  }
`;

export const AnimateBox = styled(posed.div({
  show: { opacity: 1 },
  hide: { opacity: 0 },
}))`
  opacity: 0;
`;
